import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {connect} from 'react-redux';

import {interventionPropTypes} from '../../../utils/propTypes';
import {PROJECT_STATUS, status} from '../../../utils/constant';

import ProjectTreeRowOrganisationName from './ProjectTreeRowOrganisationName';
import ProjectTreeRowOrganisationContact from './ProjectTreeRowOrganisationContact';
import ProjectTreeRowRole from './ProjectTreeRowRole';
import ProjectTreeRowDossierStateAndActions from './ProjectTreeRowDossierStateAndActions';

export function ProjectTreeRow(props) {
  const {intervention} = props;

  const isPending = intervention.status === status.PENDING;
  const isProjectNotActive = props.myIntervention.project.projectStatus !== PROJECT_STATUS.ACTIVE;
  if (isProjectNotActive && isPending) {
    return null;
  }

  const isEnded = intervention.status === status.ENDED;
  const isPendingOrRejected = [status.REJECTED, status.PENDING].includes(intervention.status);
  const isSelf = intervention.interventionId === props.myIntervention.interventionId;

  function getRowTooltip() {
    return isEnded ? I18n.t('intervention.ended.tooltip', {
      endDate: I18n.l(intervention.endDate, {dateFormat: 'datetime.shortDate'})
    }) : null;
  }

  const getOffset = () => {
    const offsets = [];
    for (let i = 0; i < intervention.depth; i++) {
      offsets.push(<div
        key={i}
        className="ml-4 ml-md-5 d-inline-block"
      />);
    }

    return offsets;
  };

  const getBorder = (size, type) => {
    const depth = intervention.depth > 3 ? 3 : intervention.depth;
    return `${size}px ${type} rgba(150, 150, 150, ${1 - (depth * 0.3)})`;
  };

  const getBorderLeft = (size, type) => {
    if (intervention.depth) {
      return getBorder(size, type);
    }

    return 'none';
  };

  const borderLeft = getBorderLeft(2, 'dotted');
  let style = {};
  if (isSelf) {
    style = Object.assign(style, {backgroundColor: '#eaf7fb'});
  }

  if (isPendingOrRejected || isEnded) {
    style = Object.assign(style, {backgroundColor: '#f5f5f5'});
  }

  style = Object.assign(style, {borderBottom: getBorder(1, 'solid')});

  return (
    <div
      tooltip={getRowTooltip()}
      className="row"
      data-id="intervention"
    >
      <div
        className="col-md-6 d-flex pr-0"
        data-id="organisation-data"
      >
        <div className="flex-shrink-0">
          {getOffset()}
        </div>
        <div
          className="flex-container space-between w-100 pr-2 pl-4 py-3"
          style={({borderLeft, ...style})}
        >
          <ProjectTreeRowOrganisationName
            intervention={props.intervention}
            myIntervention={props.myIntervention}
          />
          <ProjectTreeRowOrganisationContact intervention={props.intervention}/>
        </div>
      </div>
      <div
        className="col-md-2 pr-2 pl-4 py-3 d-flex align-items-center"
        data-id="organisation-role"
        style={style}
      >
        <ProjectTreeRowRole intervention={props.intervention}/>
      </div>
      <div
        className="col-md-4 pr-2 py-3 d-flex align-items-center"
        style={style}
      >
        <ProjectTreeRowDossierStateAndActions
          intervention={props.intervention}
          myIntervention={props.myIntervention}
          onResendInvitation={props.onResendInvitation}
          onRemoveOrganisation={props.onRemoveOrganisation}
          onSubmitEndOrganisation={props.onSubmitEndOrganisation}
          onCancelIntervention={props.onCancelIntervention}
          onRefreshProjectData={props.onRefreshProjectData}
        />
      </div>
    </div>
  );
}

ProjectTreeRow.propTypes = {
  intervention: interventionPropTypes().isRequired,
  myIntervention: interventionPropTypes().isRequired,
  organisation: PropTypes.object.isRequired,
  onResendInvitation: PropTypes.func.isRequired,
  onRemoveOrganisation: PropTypes.func.isRequired,
  onSubmitEndOrganisation: PropTypes.func.isRequired,
  onCancelIntervention: PropTypes.func.isRequired,
  onRefreshProjectData: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

export default connect(mapStateToProps)(ProjectTreeRow);
